// extracted by mini-css-extract-plugin
module.exports = {"icon-btn":"index_icon-btn__3ysJQ"};